import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { ServerUrls } from '~commonInfra/url/ServerUrls';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';

import { ConnectedApplicationDetailsSubspace } from './ConnectedApplicationDetailsSubspace';
import { ConnectedApplicationSettingSubspace } from './ConnectedApplicationSettingsSubspace';

// Not in it's own file because it simply routes to the main component (above) or to sub-subsapces
export function ConnectedApplicationSubspaceRouter() {
  const siteUrls = siteUrlsSelector(getAppStore().getState());
  return <Switch>
    <Route exact path={siteUrls.settingsConnectedApplicationsPath()} render={({ location }) => {
      return <ConnectedApplicationSettingSubspace {...location} />;
    }} />
    <Route exact path={siteUrls.connectedApplicationPath(':id')} render={({ match }) => {
      return <ConnectedApplicationDetailsSubspace {...match} />;
    }} />
    <Route exact path={ServerUrls.getInstance().settingsConnectedApplicationsPath()} render={() => {
      return <ConnectedApplicationSettingSubspace {...location} />;
    }} />
  </Switch>;
}
